import { useState, useRef } from "react";
import { useEvent as o } from "./use-event.js";
function T(l, r, c) {
  let [i, s] = useState(c), e = l !== void 0, t = useRef(e), u = useRef(false), d = useRef(false);
  return e && !t.current && !u.current ? (u.current = true, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = true, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [e ? l : i, o((n) => (e || s(n), r == null ? void 0 : r(n)))];
}
export {
  T as useControllable
};
